export const COMPANY_RADIONET_ID = 'CY00000012'
export const COMPANY_SELF_MONITORED_ID = 'CY00000308'

// export const COMPANY_TYPE_MONITORING_CENTRE_NAME = 'monitoring centre'
// export const COMPANY_TYPE_BURO_NAME = 'bureau'

// export const COMPANY_TYPE_MONITORING_CENTRE_ID = 'CT00000001'
// export const COMPANY_TYPE_BURO_ID = 'CT00000002'

export enum CompanyType {
  MonitoringCentre = 'monitoring_centre',
  Bureau = 'bureau',
  Technician = 'technician'
}

export enum CompanyTypeId {
  MonitoringCentre = 'CT00000001',
  Bureau = 'CT00000002'
}
